import React from 'react'
import classNames from 'classnames'

interface ISkeletonLoaderProps {
  as?: React.ElementType
  bgColor?: string
  children?: React.ReactNode
  className?: string
}

export function SkeletonLoader({
  as: Component = 'div',
  bgColor = 'bg-primary-100 dark:bg-coolGray-800',
  children,
  className,
}: ISkeletonLoaderProps) {
  return (
    <Component className={classNames('animate-pulse rounded-sm', bgColor, className)}>
      {children}
    </Component>
  )
}
